// Dummy registration — STRUKTUR IDENTIK dengan payload CEA To Church
// (lihat CeaToChurch.js handleSubmit). Saat modul ini diintegrasikan ke
// Approval Page nanti, cukup ganti object ini dengan data registrasi asli;
// UI & logic tidak perlu berubah.
//
// Catatan: setiap entry kelas diberi `batch` supaya buildInstallmentBreakdown
// di backend menghasilkan label bulan/tahun yang rapi (di produksi batch
// ditambahkan oleh applyBatchToClasses saat approve).

const YEARLY_ORDER = [
  "OT", "NT", "BD", "BLC", "BCMF", "MASTERCLASS",
  "HH", "CBH", "CBD", "BWG", "MMM", "CONFERENCE",
];

// completedCodes = kelas yang sudah pernah diikuti (status "completed" → tidak
// ditagih lagi oleh helper pricing existing).
const yearlyClasses = (batch, completedCodes = []) =>
  YEARLY_ORDER.map((name) => ({
    name,
    status: completedCodes.includes(name) ? "completed" : "requested",
    batch,
  }));

// Satu registrasi campuran: 1 Year Program penuh + 1 Month Course +
// 1 Year Program yang sudah pernah mengikuti kelas HH (HH "completed").
export const dummyRegistration = {
  churchName: "IFGF Example Church",
  picName: "John Doe (PIC)",
  picEmail: "pic@example.com",
  picPhone: "6281234567890",
  churchCity: "Bandung",
  paymentPlan: "installment",
  students: [
    {
      name: "Peter Student",
      email: "peter@example.com",
      phoneNumber: "6281111111111",
      program: "1 Year Program",
      classType: "Onsite",
      studentPackage: "The House Convention Hall",
      role: "HITS/Mth Student",
      startingClass: "OT",
      classes: { className: yearlyClasses("4") },
    },
    {
      name: "Mary Student",
      email: "mary@example.com",
      phoneNumber: "6282222222222",
      program: "1 Month Course",
      classType: "Online",
      studentPackage: "Shipping",
      role: "Attendees (IFGF BDG)",
      startingClass: "OT",
      classes: {
        className: [
          { name: "OT", status: "requested", batch: "4" },
          { name: "NT", status: "requested", batch: "4" },
        ],
      },
    },
    {
      name: "Daniel Returning",
      email: "daniel@example.com",
      phoneNumber: "6283333333333",
      program: "1 Year Program",
      classType: "Onsite",
      studentPackage: "The House Convention Hall",
      role: "Coach",
      startingClass: "OT",
      // Sudah pernah mengikuti HH → HH "completed" (tidak ditagih lagi).
      classes: { className: yearlyClasses("4", ["HH"]) },
    },
  ],
};
